/* Ximena Robledo - línea de envío bajo "Compra más, ahorra más" (minimalista) */
(function () {
  'use strict';
  var FLAG = '<svg class="xr-ship__flag" viewBox="0 0 28 16" aria-label="México" role="img">' +
    '<rect width="9.34" height="16" fill="#006847"/><rect x="9.33" width="9.34" height="16" fill="#fff"/><rect x="18.66" width="9.34" height="16" fill="#ce1126"/>' +
    '<path d="M11.2 9.6c.6 1.5 1.6 2.2 2.8 2.2s2.2-.7 2.8-2.2" fill="none" stroke="#3d7a36" stroke-width=".9" stroke-linecap="round"/>' +
    '<ellipse cx="14" cy="7.6" rx="1.9" ry="2.3" fill="#7a4a1e"/>' +
    '<path d="M12.6 6.1l-1.3-1 1.7.2M15.4 6.1l1.3-1-1.7.2" fill="none" stroke="#7a4a1e" stroke-width=".7" stroke-linecap="round"/>' +
    '<ellipse cx="14" cy="10.4" rx="1.2" ry=".45" fill="#2e7fb0"/>' +
    '</svg>';
  function build() {
    var vol = document.querySelector('.xr-vol');
    if (!vol || document.querySelector('.xr-ship')) return;
    var tz = 'America/Mexico_City';
    var ymd = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
    var d = new Date(Date.UTC(+ymd[0], +ymd[1] - 1, +ymd[2] + 1, 12));
    var wd = new Intl.DateTimeFormat('es-MX', { weekday: 'short', timeZone: 'UTC' }).format(d).replace('.', '');
    var dm = new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d).replace('.', '');
    var el = document.createElement('p');
    el.className = 'xr-ship';
    el.innerHTML =
      '<span class="xr-ship__dot" aria-hidden="true"></span>' +
      '<span>Se envía el <b></b></span>' +
      '<span class="xr-ship__sep" aria-hidden="true">·</span>' +
      FLAG +
      '<span>Envío gratis a México</span>';
    el.querySelector('b').textContent = wd + ', ' + dm;
    vol.appendChild(el);
  }
  var css = document.createElement('style');
  css.textContent =
    '.xr-ship{display:flex;align-items:center;justify-content:center;gap:7px;margin:10px 0 0;padding:0;font-size:11.5px;letter-spacing:.03em;color:var(--xr-ink);opacity:.85;white-space:nowrap}' +
    '.xr-ship b{font-weight:600}' +
    '.xr-ship__dot{width:6px;height:6px;border-radius:50%;background:#2f7d4f;flex:none;animation:xrShipBlink 2.6s ease-in-out infinite}' +
    '@keyframes xrShipBlink{0%,100%{opacity:1}50%{opacity:.3}}' +
    '.xr-ship__sep{opacity:.4;margin:0 2px}' +
    '.xr-ship__flag{width:21px;height:12px;flex:none;box-shadow:0 0 0 .5px rgba(0,0,0,.15)}' +
    '@media (max-width:360px){.xr-ship{font-size:11px;gap:5px}}' +
    '@media (prefers-reduced-motion:reduce){.xr-ship__dot{animation:none}}';
  document.head.appendChild(css);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();